import { lazy } from 'react';

import Loadable from 'components/Loadable';
import AuthLayout from 'layout/Auth';
import GuestGuard from 'utils/route-guard/GuestGuard';

const AuthLogin = Loadable(lazy(() => import('pages/auth/Login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/Register')));

const LoginRoutes = {
  path: '/',
  element: <GuestGuard><AuthLayout /></GuestGuard>,
  children: [
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'register',
      element: <AuthRegister />
    }
  ]
};

export default LoginRoutes;
